<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 section" id="copyright-information">
<h1>Copyright Information ©</h1>
<p>Peter King (2020)</p>
<p>The right of Peter King to be identified as author of this work has been asserted by him in accordance with section 77 and 78 of the Copyright, Designs and Patents Act 1988.</p>
<p>All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<p>Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p>A CIP catalogue record for this title is available from the British Library.</p>
<p>ISBN 9781528946056 (Paperback)</p>
<p>ISBN 9781528946063 (Hardback)</p>
<p>ISBN 9781528971638 (ePub e-book)</p>
<p>www.austinmacauley.com</p>
<p>First Published (2020)</p>
<p>Austin Macauley Publishers Ltd</p>
<p>25 Canada Square</p>
<p>Canary Wharf</p>
<p>London</p>
<p>E14 5LQ</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?10087afc